import { render, staticRenderFns } from "./FscInputIban.vue?vue&type=template&id=f2c83d3c&"
import script from "./FscInputIban.vue?vue&type=script&lang=ts&"
export * from "./FscInputIban.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports